import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlueEditIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 46,
	viewBox: "0 0 44 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 26.891,
			cy: 28.3472,
			rx: 3.76599,
			ry: 3.48103,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 22,
			cy: 26.0423,
			rx: 17,
			ry: 16.9612,
			fill: "#E9F0FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.5318,
			cy: 37.298,
			rx: 2.53176,
			ry: 2.48645,
			fill: "#CCDEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 33.0127,
			cy: 43.7592,
			rx: 1.0127,
			ry: .994581,
			fill: "#CCDEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.0127,
			cy: .994581,
			rx: 1.0127,
			ry: .994581,
			fill: "#CCDEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.5,
			cy: 7.45911,
			rx: 2.5,
			ry: 2.48645,
			fill: "#E9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 45C28.9 45 37 36.9 37 27C37 17.1 28.9 9 19 9C9.1 9 1 17.1 1 27C1 36.9 9.1 45 19 45Z",
			stroke: "#2D59AB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2633 20.4391L12.0533 29.1291C11.7433 29.4591 11.4433 30.1091 11.3833 30.5591L11.0133 33.7991C10.8833 34.9691 11.7233 35.7691 12.8833 35.5691L16.1033 35.0191C16.5533 34.9391 17.1833 34.6091 17.4933 34.2691L25.7033 25.5791C27.1233 24.0791 27.7633 22.3691 25.5533 20.2791C23.3533 18.2091 21.6833 18.9391 20.2633 20.4391Z",
			stroke: "#2D59AB",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8906 21.8906C19.3206 24.6506 21.5606 26.7606 24.3406 27.0406",
			stroke: "#2D59AB",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBlueEditIcon;
